module.exports = __webpack_public_path__ + "static/media/instagram.75539fa3.png";